import { useQuery } from "@tanstack/react-query";

import { VerifyApiApi } from "../api/verifyApiApi";

export const VerifyApiQueryKeys = {
  all: ["verify_api"] as const,
  shortCodeData: (shortCode: string) =>
    [...VerifyApiQueryKeys.all, shortCode] as const,
};

export const useGetShortCodeDataQuery = (shortCode: string) => {
  return useQuery({
    queryKey: VerifyApiQueryKeys.shortCodeData(shortCode),
    queryFn: () => VerifyApiApi.getShortCodeData(shortCode),
    enabled: Boolean(shortCode),
  });
};
